import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import RatingComponent from "./components/RatingComponent";
import { useTranslation } from "@i18n";
var PriceOfferSuccessPage = function PriceOfferSuccessPage() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:max-w-[360px] md:mx-auto pt-10 md:pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/success.svg",
    alt: "",
    height: "82",
    width: "96"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary font-bold text-2xl text-center"
  }, tShort("price_offer/success_normal_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] font-regular text-base text-center"
  }, tShort("price_offer/success_description", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RatingComponent, null))));
};
export default PriceOfferSuccessPage;